import Popup from '@/components/PopupContainer/Popup';
import { handleJoinMeetLink } from '@/features/calendar/utils/meetLinkHelper';
import { useLanguage } from '@/localization/useLanguage';
import { blockOfflineAction, showInfoToast } from '@/shared/utils';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import './MeetPopup.scss';
import { CopyIcon, IconSelectTick } from '@/assets/images';

const MeetPopup = ({ isOpen, onClose, meetLink, loading }) => {
   const { t } = useLanguage();
   const dispatch = useDispatch();
   const [copied, setCopied] = useState(false);

   const handleCopyLink = useCallback(() => {
      if (meetLink) {
         navigator.clipboard
            .writeText(meetLink)
            .then(() => {
               showInfoToast(t('common.LINK_COPIED'));
               setCopied(true);
               setTimeout(() => setCopied(false), 2000);
            })
            .catch(() => {});
      }
   }, [meetLink]);

   const handleJoinMeeting = useCallback(() => {
      if (!meetLink || blockOfflineAction()) return;
      onClose();
      handleJoinMeetLink(meetLink, dispatch);
   }, [meetLink, dispatch, onClose]);

   return (
      <Popup isOpen={isOpen} onClose={onClose} hideHeader className="meet-popup-container">
         <div className="meet-popup ct-flex ct-fcol ct-gap32">
            <div className="ct-flex ct-fcol ct-gap8">
               <h2 className="meet-popup__title ct-flex">{t('calendar.INSTANT_MEET')}</h2>
               <p className="meet-popup__subtitle ct-flex">{t('calendar.COPY_LINK_SUBTITLE')}</p>
            </div>
            {/* Link Row */}
            <div className="meet-popup__link-row ct-flex ct-aiCenter ct-gap8">
               <span className="meet-popup__link-text ct-flex1">
                  {loading ? t('calendar.LOADING') : meetLink || t('calendar.LOADING')}
               </span>
               <button
                  className="meet-popup__copy-btn ct-cursor ct-flexCenter ct-flexShrink0"
                  onClick={handleCopyLink}
                  disabled={loading || !meetLink || copied}
                  aria-label={copied ? 'Link copied' : 'Copy link'}
               >
                  {copied ? (
                     <i className="ct-icon sm success-tick" style={{ color: '#00c853' }}>
                        <IconSelectTick />
                     </i>
                  ) : (
                     <i className="ct-icon sm">
                        <CopyIcon />
                     </i>
                  )}
               </button>
            </div>

            {/* Join Button */}
            <button
               className="ct-flex ct-aiCenter ct-jcCenter meet-popup__join-btn ct-cursor"
               onClick={handleJoinMeeting}
               disabled={loading || !meetLink}
            >
               {t('calendar.JOIN_MEETING')}
            </button>
         </div>
      </Popup>
   );
};

MeetPopup.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   onClose: PropTypes.func.isRequired,
   meetLink: PropTypes.string,
   loading: PropTypes.bool,
};

export default MeetPopup;
